import { ChangeDetectorRef, ViewEncapsulation, Component, OnInit,AfterViewInit, ElementRef, ViewChild,
	Input, OnChanges, OnDestroy, Output, SimpleChanges, EventEmitter } from '@angular/core';
	import { CookieService } from '../_services/cookie.service';
	import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
	import {UploadService} from '../_services/index';
	import {UploadAdapter} from '../uploadadapter';
	import { CkdataService } from '../inservice/ckdata.service';
	import {HttpClient} from '@angular/common/http';
	import {environment} from '../../environments/environment';
	import { 
        ClassicEditor,
        InlineEditor, 
        AutoImage,
		Autosave,
		//BalloonToolbar,
		BlockQuote,
		//CKBox,
		//CKBoxImageEdit,
		GeneralHtmlSupport,
		CloudServices,
		Heading,
		ImageBlock,
		ImageCaption,
		ImageInline,
		ImageInsert,
		ImageInsertViaUrl,
		ImageResize,
		ImageStyle,
		ImageTextAlternative,
		ImageToolbar,
		ImageUpload,
		Alignment,
		Indent,
		IndentBlock,
		SourceEditing,
		Link,
		LinkImage,
		ListProperties,
		Strikethrough, 
		Subscript, 
		Superscript, 
		MediaEmbed,
		PasteFromOffice,
		PictureEditing,
		SelectAll,
		Table,
		TableCaption,
		TableCellProperties,
		TableColumnResize,
		TableProperties,
		TableToolbar,
		TextTransformation,
		TodoList,
		Underline,
		Autoformat, Bold, Essentials, Italic, List, SpecialCharacters, Mention, Paragraph, Undo, FontFamily, FontSize, FontBackgroundColor, type EditorConfig } from 'ckeditor5';
	import { Comments, TrackChanges, TrackChangesData,PasteFromOfficeEnhanced, CaseChange, AIAssistant,  OpenAITextAdapter} from 'ckeditor5-premium-features';
	import {
		CommentsIntegration,
		TrackChangesIntegration,
		UsersIntegration,
		SpecialCharactersCheckMarks,
		FontColor,
		FootNote,
		ReadOnly,
		Placeholder,
		LineHeight
	} from '../ckeditor5/plugins';
	const LICENSE_KEY = `${environment.api.ckTrackChangeKey}`;	
	declare var $: any;
	@Component({
	  selector: 'app-paragraph',
	  templateUrl: './paragraph.component.html',
	  styleUrls: ['./paragraph.component.css'],
	  encapsulation: ViewEncapsulation.None
	})
	export class ParagraphComponent implements OnInit {
		public model = {
			editorData: '',
			suggestions:[],
			comments:[]
		};
		ifSrc='N';
		@Input() editorType:string;
		@Input() content:string;
		@Input() suggests:any;
		@Input() comments:any;
		@Input() users:any;
		@Input() insert:any;
		@Input() insertSign:any;
		@Input() getText:number;
		@Input() addedSlot:any;
		@Input() addedPara:any;
		@Input() srcViewer:string;
		@Input() ifReadOnly:boolean;
		@Output() outText = new EventEmitter<string>(true);
		@Output() onExit = new EventEmitter<string>(true);
		@Output() onTrackChange = new EventEmitter<any>(true);
		@Output() selected = new EventEmitter<boolean>(true);
		@Output() rfSelected = new EventEmitter<string>();
		public isLayoutReady = false;
		public Editor = ClassicEditor;
		public config: EditorConfig = {};
		private alluser=[];
		public docs=[];
		public docList=[];
		public docIndex:number;
		public isLib=false;
		public isFO=false;
		public appData:any;		
	public ngAfterViewInit(): void {
		if(this.editorType=='lite'){
			this.config = {
			htmlSupport: {
				allow: [
					{
						name: /.*/,
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'div',
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'p',
						attributes: true,
						classes: true,
						styles: true
					},
				]
			},
			plugins: [
				CaseChange,
				Bold,
				Essentials,
				Italic,
				SpecialCharacters,
				Mention,
				Paragraph,
				Undo,
					Autoformat,
					AutoImage,
					Autosave,
					BlockQuote,
					Bold,
					Essentials,
					Heading,
					ImageBlock,
					ImageCaption,
					ImageInline,
					ImageInsert,
					ImageInsertViaUrl,
					ImageResize,
					ImageStyle,
					ImageTextAlternative,
					ImageToolbar,
					ImageUpload,
					Alignment,
					Indent,
					IndentBlock,
					Italic,
					SourceEditing,
					Link,
					LinkImage,
					List,
					ListProperties,
					Mention,
					Paragraph,
					PasteFromOffice,
					GeneralHtmlSupport,
					PictureEditing,
					SelectAll,
					Table,
					TableCaption,
					TableCellProperties,
					TableColumnResize,
					TableProperties,
					TableToolbar,
					TextTransformation,
					TodoList,
					Strikethrough, 
					Subscript, 
					Superscript, 
					Underline,
					Undo,FontFamily, FontSize,FontBackgroundColor,
					
			],
			extraPlugins: [
				SpecialCharactersCheckMarks,
				FontColor,	
				LineHeight,
				ReadOnly,
				Placeholder			
			],			
			toolbar:{
				items:[
					//'heading',
					//'|',
					'bulletedList',
					'numberedList',
					'todoList',
					'|',
					'alignment',
					'outdent',
					'indent',
					'lineHeight',					
					'|',
					'specialCharacters',
					'blockQuote',
					'link',
					'|',
					'readonly',
					'|',
					'sourceEditing',
					'|',
					'caseChange',
					'bold',
					'italic',
					'fontSize',
					'fontFamily',
					'fontColor',
					'fontBackgroundColor',
					'|',
					'underline',
					'strikethrough',
					'subscript',
					'superscript',
					'|',
					'undo',
					'redo',		
				],
				shouldNotGroupWhenFull: true
			},
			heading: {
				options: [
					{
						model: 'paragraph',
						title: 'Paragraph',
						class: 'ck-heading_paragraph'
					},
					{
						model: 'heading1',
						view: 'h1',
						title: 'Heading 1',
						class: 'ck-heading_heading1'
					},
					{
						model: 'heading2',
						view: 'h2',
						title: 'Heading 2',
						class: 'ck-heading_heading2'
					},
					{
						model: 'heading3',
						view: 'h3',
						title: 'Heading 3',
						class: 'ck-heading_heading3'
					},
					{
						model: 'heading4',
						view: 'h4',
						title: 'Heading 4',
						class: 'ck-heading_heading4'
					},
					{
						model: 'heading5',
						view: 'h5',
						title: 'Heading 5',
						class: 'ck-heading_heading5'
					},
					{
						model: 'heading6',
						view: 'h6',
						title: 'Heading 6',
						class: 'ck-heading_heading6'
					}
				]
			},
			fontSize: {
				options: [ 6, 7, 8, 9, 10, 11, 12, 'default', 16, 18, 20],
				supportAllValues: true
			},
			language: 'en',
			initialData:this.model.editorData,
			placeholder: 'Type or paste your content here!',
			licenseKey: LICENSE_KEY
		};
	}else if(this.editorType=='temp'){
		this.config = {
			htmlSupport: {
				allow: [
					{
						name: /.*/,
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'div',
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'p',
						attributes: true,
						classes: true,
						styles: true
					},
				]
			},
			plugins: [
				CaseChange,
				Bold,
				Essentials,
				Italic,
				SpecialCharacters,
				Mention,
				Paragraph,
				Undo,
					Autoformat,
					AutoImage,
					Autosave,
					BlockQuote,
					Bold,
					Essentials,
					Heading,
					ImageBlock,
					ImageCaption,
					ImageInline,
					ImageInsert,
					ImageInsertViaUrl,
					ImageResize,
					ImageStyle,
					ImageTextAlternative,
					ImageToolbar,
					ImageUpload,
					Alignment,
					Indent,
					IndentBlock,
					Italic,
					SourceEditing,
					Link,
					LinkImage,
					List,
					ListProperties,
					Mention,
					Paragraph,
					PasteFromOffice,
					GeneralHtmlSupport,
					PictureEditing,
					SelectAll,
					Table,
					TableCaption,
					TableCellProperties,
					TableColumnResize,
					TableProperties,
					TableToolbar,
					TextTransformation,
					TodoList,
					Strikethrough, 
					Subscript, 
					Superscript, 
					Underline,
					Undo,FontFamily, FontSize,FontBackgroundColor,
					
			],
			extraPlugins: [
				SpecialCharactersCheckMarks,
				FontColor,
				FootNote,
				LineHeight,
				ReadOnly,
				Placeholder
			],
			toolbar:{
				items:[
					//'heading',
					//'|',
					'bulletedList',
					'numberedList',
					'todoList',
					'|',
					'alignment',
					'outdent',
					'indent',
					'lineHeight',
					'|',
					'specialCharacters',
					//'insertImageViaUrl',
					'insertTable',
					'blockQuote',
					'link',
					'|',
					'readonly',
					'|',
					'sourceEditing',
					'-',
					'caseChange',
					'bold',
					'italic',
					'fontSize',
					'fontFamily',
					'fontColor',
					'fontBackgroundColor',
					'|',
					'underline',
					'strikethrough',
					'subscript',
					'superscript',
					'|',
					'undo',
					'redo',
				],
				shouldNotGroupWhenFull: true
			},
			heading: {
				options: [
					{
						model: 'paragraph',
						title: 'Paragraph',
						class: 'ck-heading_paragraph'
					},
					{
						model: 'heading1',
						view: 'h1',
						title: 'Heading 1',
						class: 'ck-heading_heading1'
					},
					{
						model: 'heading2',
						view: 'h2',
						title: 'Heading 2',
						class: 'ck-heading_heading2'
					},
					{
						model: 'heading3',
						view: 'h3',
						title: 'Heading 3',
						class: 'ck-heading_heading3'
					},
					{
						model: 'heading4',
						view: 'h4',
						title: 'Heading 4',
						class: 'ck-heading_heading4'
					},
					{
						model: 'heading5',
						view: 'h5',
						title: 'Heading 5',
						class: 'ck-heading_heading5'
					},
					{
						model: 'heading6',
						view: 'h6',
						title: 'Heading 6',
						class: 'ck-heading_heading6'
					}
				]
			},
			table: {
				contentToolbar: [
					'tableColumn',
					'tableRow',
					'mergeTableCells',
					'tableProperties', 
					'tableCellProperties'
				]
			},
			fontSize: {
				options: [ 6, 7, 8, 9, 10, 11, 12, 'default', 16, 18, 20],
				supportAllValues: true
			},
			language: 'en',
			initialData:this.model.editorData,
			placeholder: 'Type or paste your content here!',
			licenseKey: LICENSE_KEY
		};
	}else{
		let that=this;
		this.config = {
			htmlSupport: {
				allow: [
					{
						name: /.*/,
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'div',
						attributes: true,
						classes: true,
						styles: true
					},
					{
						name: 'p',
						attributes: true,
						classes: true,
						styles: true
					},
				]
			},
			plugins: [
				OpenAITextAdapter, 
				AIAssistant, 
				CaseChange,
				Bold,
				Essentials,
				Italic,
				SpecialCharacters,
				Mention,
				Paragraph,
				Undo,
				Comments,
				TrackChanges,
				TrackChangesData,
					Autoformat,
					AutoImage,
					Autosave,
					BlockQuote,
					Bold,
					Comments,
					Essentials,
					Heading,
					ImageBlock,
					ImageCaption,
					ImageInline,
					ImageInsert,
					ImageInsertViaUrl,
					ImageResize,
					ImageStyle,
					ImageTextAlternative,
					ImageToolbar,
					ImageUpload,
					Alignment,
					Indent,
					IndentBlock,
					Italic,
					SourceEditing,
					Link,
					LinkImage,
					List,
					ListProperties,
					Mention,
					Paragraph,
					PasteFromOffice,
					GeneralHtmlSupport,
					PictureEditing,
					SelectAll,
					Table,
					TableCaption,
					TableCellProperties,
					TableColumnResize,
					TableProperties,
					TableToolbar,
					TextTransformation,
					TodoList,
					Strikethrough, 
					Subscript, 
					Superscript, 
					Underline,
					Undo,FontFamily, FontSize,FontBackgroundColor,
					
			],
			extraPlugins: [
				UsersIntegration,
				CommentsIntegration,
				TrackChangesIntegration,
				SpecialCharactersCheckMarks,
				FontColor,
				FootNote,
				LineHeight,
				ReadOnly,
				Placeholder
			],
			toolbar:{
				items:[
					//'heading',
					'bulletedList',
					'numberedList',
					'todoList',
					'|',
					'alignment',
					'outdent',
					'indent',
					'lineHeight',
					'|',
					'caseChange',
					'bold',
					'italic',
					'fontSize',
					'fontFamily',
					'fontColor',
					'fontBackgroundColor',
					'|',
					'specialCharacters',
					'insertImageViaUrl',
					'insertTable',
					'blockQuote',
					'link',
					'|',
					'readonly',
					'|',
					'sourceEditing',
					'|',
					//'bold',
					//'italic',
					//'fontSize',
					//'fontFamily',
					//'fontColor',
					//'fontBackgroundColor',
					'|',
					'underline',
					'strikethrough',
					'subscript',
					'superscript',
					'|',
					'undo',
					'redo',
					'trackChanges', 
					'comment', 
					'commentsArchive',
					'|',
					'aiCommands', 'aiAssistant',
					
				],
				shouldNotGroupWhenFull: true
			},
			ai: {
				/*openAI: {
					requestHeaders: {
						// Paste your OpenAI API key in place of YOUR_OPENAI_API_KEY:
						Authorization: openAI_KEY,
					}
				}*/
				openAI: {
					apiUrl: `${environment.api.ckProxy}`,//'http://localhost:8000/generate',
					/*requestHeaders: {
						'Authorization': 'Bearer YOUR_API_KEY'
					}*/
					requestHeaders: async () => {
						//const jwt = await fetch( 'https://url.to.your.auth.endpoint/' );
						const jwt = JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
						const id = this.cookieService.getCookie("userID");
						return {
							Authorization: 'Bearer ' + jwt + ';;' +id
						};
					}
				}
			},
			comments: {
				editorConfig: {
					extraPlugins: [Autoformat, Bold, Italic, List]
				}
			},
			heading: {
				options: [
					{
						model: 'paragraph',
						title: 'Paragraph',
						class: 'ck-heading_paragraph'
					},
					{
						model: 'heading1',
						view: 'h1',
						title: 'Heading 1',
						class: 'ck-heading_heading1'
					},
					{
						model: 'heading2',
						view: 'h2',
						title: 'Heading 2',
						class: 'ck-heading_heading2'
					},
					{
						model: 'heading3',
						view: 'h3',
						title: 'Heading 3',
						class: 'ck-heading_heading3'
					},
					{
						model: 'heading4',
						view: 'h4',
						title: 'Heading 4',
						class: 'ck-heading_heading4'
					},
					{
						model: 'heading5',
						view: 'h5',
						title: 'Heading 5',
						class: 'ck-heading_heading5'
					},
					{
						model: 'heading6',
						view: 'h6',
						title: 'Heading 6',
						class: 'ck-heading_heading6'
					}
				]
			},
			image: {
				toolbar: [
					'toggleImageCaption',
					'imageTextAlternative',
					'|',
					'imageStyle:inline',
					'imageStyle:wrapText',
					'imageStyle:breakText',
					'|',
					'resizeImage',					
				]
			},
			table: {
				contentToolbar: [
					'tableColumn',
					'tableRow',
					'mergeTableCells',
					'tableProperties', 
					'tableCellProperties'
				]
			},
			fontSize: {
				options: [ 6, 7, 8, 9, 10, 11, 12, 'default', 16, 18, 20],
				supportAllValues: true
			},
			language: 'en',
			initialData:this.model.editorData,
			placeholder: 'Type or paste your content here!',
			licenseKey: LICENSE_KEY
		};
	}
        this.isLayoutReady = true;
		this.changeDetector.detectChanges();
    }
		
		@ViewChild('myEditor') myEditor: CKEditorComponent;
		@ViewChild('srcModal') srcModal: ElementRef;
		@ViewChild('editorAnnotationsElement') private editorAnnotations!: ElementRef<HTMLDivElement>;		
		constructor( private cookieService:CookieService,private changeDetector: ChangeDetectorRef, private uls: UploadService, private http:HttpClient, private ckdataService: CkdataService) {
			//sessionStorage.clear();
			let userName:any;
			userName= this.cookieService.getCookie("userName");
			const cleanUserName=userName.replaceAll(','," ");
			this.alluser=[cleanUserName];console.log(this.alluser)
			//sessionStorage.setItem('commUser1', userName);
			sessionStorage.setItem('commUser', JSON.stringify(this.alluser));
		 }
			
	  ngOnInit(): void {
		
		$(document).ready(function () {
				$('#srcModal').draggable();	
		});
	  }
	  ngOnChanges(changes: SimpleChanges): void {
		if('users' in changes){//console.log(this.users)
			if(this.users&&this.users.length>0){
				for(let user of this.users){
					if(user&&(!this.alluser.includes(user))){
						let cleanUserName=user.replaceAll(','," ");
						this.alluser.push(cleanUserName);	
					}											
				}
				sessionStorage.setItem('commUser', JSON.stringify(this.alluser));//console.log(this.alluser)
			}
		}
			if ('insert' in changes) {
				if((this.insert)&&(this.insert.FILE_URL.length>0)){
					this.elementClick(this.insert); 
				}
			}
			if ('insertSign' in changes) {
				if(this.insertSign){
					this.addSign(this.insertSign); 
				}
			}
			if('suggests' in changes){console.log(this.suggests)
				if(!this.suggests){
					this.suggests=[];
				}else{
					for(let suggest of this.suggests){
						suggest.createdAt=new Date(suggest.createdAt);
						sessionStorage.setItem(suggest.id, JSON.stringify(suggest));
					}
																
				}

			}
			if('comments' in changes){console.log(this.comments)
				if(!this.comments){
					this.comments=[];	
					sessionStorage.removeItem('commentThreads')				
				}else{
					sessionStorage.setItem('commentThreads', JSON.stringify(this.comments));											
				}
			}
			
			if ('addedSlot' in changes) {
				if(this.addedSlot&&this.addedSlot.content){
					if (this.addedSlot.type=='slot'){
						let content=JSON.parse(this.addedSlot.content);
						this.addSlot2(content);
					}else{
						let content=this.addedSlot.content;
						this.addSlot(content,this.addedSlot.type );
					}
					this.model.editorData = this.getCKContent();
				}
			}
			if ('addedPara' in changes) {
				if(this.addedPara&&this.addedPara.content){
					this.addPara(this.addedPara.content);
				}
			}
			if('editorType' in changes){
				if(this.editorType=='lite'){
					this.editorType='lite';
				}else if(this.editorType=='temp'){
					this.editorType='temp';
				}
			}
			if('content' in changes){
				if(!this.content){
					this.content='';
					this.model.editorData='';
				}else{				
					this.model.editorData=this.content;
					
				}

			}
			
			if('getText' in changes){
				if(this.getText>0){
					if(this.myEditor){
						let editor=this.myEditor.editorInstance;
						this.model.editorData = this.getCKContent();
						const txt=$(editor.getData()).text();
						const tracks=this.model.suggestions.length+this.model.comments.length;
						if(tracks>0){
							let item={'html':this.model.editorData, 'text':txt, 'suggestions':this.model.suggestions, 'comments':this.model.comments};
							this.onTrackChange.emit(item);
						}else{
							this.outText.emit(txt);
							this.onExit.emit(this.model.editorData);				
						}
					}
				}
			}
			if('srcViewer' in changes){
				this.ifSrc = 'N';
			}
		}
		onReady(eventData) {
			if(!this.editorType){
				eventData.plugins.get('TrackChangesEditing')?.enableCommand('placeholder');
			
				let that=this;
				eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
				
				let data=new UploadAdapter(loader,that.http);
				return data
				};
		}
            eventData.execute( 'fontFamily', { value: 'Courier New, Courier, monospace' } );
            eventData.focus();
		}	
		private getCKContent() {
		if (this.myEditor && this.myEditor.editorInstance) {
			const editorData = this.myEditor.editorInstance.data.get();
			//const revisionsData = ( this.myEditor.editorInstance.plugins.get( 'RevisionsRepository' ) as RevisionsRepository ).getRevisions();
			if(!this.editorType){
			const suggestionsData = ( this.myEditor.editorInstance.plugins.get( 'TrackChanges' ) as TrackChanges ).getSuggestions({
                skipNotAttached: true,
                toJSON: true
            });
			const commentsRepository = this.myEditor.editorInstance.plugins.get( 'CommentsRepository' );
			const commentThreadsData = commentsRepository.getCommentThreads( {
                skipNotAttached: true,
                skipEmpty: true,
                toJSON: true
            } );
			console.log( 'Suggestions data:' );
			console.log( suggestionsData );
			//console.log( 'NoSuggestions data:' );
			//console.log( textdata );
			console.log( 'Comment data:' );
			console.log( commentThreadsData );
			this.model.suggestions=suggestionsData;
			this.model.comments=commentThreadsData;
		}
			return this.myEditor.editorInstance.getData();
			
		}	
		return '';
	  }
	private elementClick(arg) {
		if(arg){
		const selection = this.myEditor.editorInstance.model.document.selection;
		const imgUrl=arg.FILE_URL;
		const range = selection.getFirstRange();
		this.myEditor.editorInstance.model.change(writer => {
			 const imageElement = writer.createElement( 'imageInline', {
				src: imgUrl,
				alt: 'Your Image'
			} );
			
			writer.insert(imageElement, range.start);	
			this.myEditor.editorInstance.focus;	        
		});
		}	
	  }
	  private addSign(arg) {
		if(arg){
			if(this.myEditor){
		const selection = this.myEditor.editorInstance.model.document.selection;
		const imgUrl=arg.FILE_URL;
		const name=arg.FILE_NAME;
		const range = selection.getFirstRange();
		this.myEditor.editorInstance.model.change(writer => {
			 const imageElement = writer.createElement( 'imageInline', {
				src: imgUrl,
				alt: name,
				class: "image_resized",
				style: "width:"+arg.height,
			} );
			
			writer.insert(imageElement, range.start);
			this.myEditor.editorInstance.focus();			        
		});
			this.myEditor.editorInstance.model.deleteContent(selection);}
		}	
	  }
	
	  private addSlot2(content) {
		if(this.myEditor){
		let editor=this.myEditor.editorInstance;
		editor.execute('placeholder', { 'name': content.name, 'dataId': content.dataId, 'dataType': content.dataType, 'dataStatus': content.status });
		editor.focus();
		}
	}
	
	 
		private addSlot(content, type) {
			if(this.isLib){
				content='<br />'+content; 
			}
			if(this.isFO){
				content='&nbsp;'+content; 
			}
			if(this.myEditor){
			let editor=this.myEditor.editorInstance;
			const viewFragment = editor.data.processor.toView( content );
			const modelFragment = editor.data.toModel( viewFragment );
			editor.model.change( writer => {
				editor.model.insertContent(modelFragment);	
				editor.focus();			
			});
			this.model.editorData = this.getCKContent()
			const txt=$(editor.getData()).text();
			const tracks=this.model.suggestions.length+this.model.comments.length;
			if(tracks>0){
				let item={'html':this.model.editorData, 'text':txt, 'suggestions':this.model.suggestions, 'comments':this.model.comments};
				this.onTrackChange.emit(item);
			}else{
				this.outText.emit(txt);
				this.onExit.emit(this.model.editorData);				
			}
			}
			if(type=='lib'){
				this.isLib=true;
			}
			if(type=='FO'){
				this.isFO=true;
			}
			
		}
		private addPara(content) {
			if(this.myEditor){
			let editor=this.myEditor.editorInstance;
			const viewFragment = editor.data.processor.toView( content );
			const modelFragment = editor.data.toModel( viewFragment );
			editor.model.change( writer => {
				editor.model.insertContent(modelFragment);	
				editor.focus();		
			});
			this.model.editorData = this.getCKContent();
			const txt=$(editor.getData()).text();
			const tracks=this.model.suggestions.length+this.model.comments.length;
			if(tracks>0){
				let item={'html':this.model.editorData, 'text':txt, 'suggestions':this.model.suggestions, 'comments':this.model.comments};
				this.onTrackChange.emit(item);
			}else{
				this.outText.emit(txt);
				this.onExit.emit(this.model.editorData);				
			}
			
			}
		}
		saveData(e){
			this.model.editorData = this.getCKContent();
			const txt=$(e.editor.getData()).text();
			const tracks=this.model.suggestions.length+this.model.comments.length;
			if(tracks>0){console.log('tosuggest')
				let item={'html':this.model.editorData, 'text':txt, 'suggestions':this.model.suggestions, 'comments':this.model.comments};
				this.onTrackChange.emit(item);
			}else{console.log('toNotrack')
				this.outText.emit(txt);
				this.onExit.emit(this.model.editorData);				
			}
			
		}
		selecte(){
			this.selected.emit(true);
		}
		showViewer(){
			$(this.srcModal.nativeElement).modal('show');
		}
		closeModal(){
			let editor=this.myEditor.editorInstance;
			const txt=$(editor.getData()).text();
			const tracks=this.model.suggestions.length+this.model.comments.length;
			if(tracks>0){
				let item={'html':this.model.editorData, 'text':txt, 'suggestions':this.model.suggestions, 'comments':this.model.comments};
				this.onTrackChange.emit(item);
			}else{
				this.outText.emit(txt);
				this.onExit.emit(this.model.editorData);				
			}
			
	   }
	   change({ event, editor }) {//console.log(event, editor)
		   const element = editor.model.document.selection.getSelectedElement();
		   if (element && element.name === 'placeholder') {
			   const dataId = element.getAttribute('dataId');
			   const dataType = element.getAttribute('dataType');
			   const dataStatus = element.getAttribute('dataStatus');
			  // console.log('selected placeholder = { dataId: "' + dataId + '", dataType: "' + dataType + '", dataStatus: "' + dataStatus + '" }');
			   this.rfSelected.emit(dataId);
		   }
		   //this.myEditor.editorInstance.focus();	
		   
	   }
	   resetLib(){
			this.isLib=false;
			this.isFO=false;
	   }
	}
	